// Build-time origin from DefinePlugin (e.g. "https://mazed-widget.vercel.app").
// Falls back to runtime DOM detection, then window.location.origin.
const _resolvedOrigin = (() => {
    if (typeof __WIDGET_ORIGIN__ !== 'undefined' && __WIDGET_ORIGIN__) {
        return __WIDGET_ORIGIN__;
    }
    if (typeof document === 'undefined')
        return '';
    try {
        if (document.currentScript instanceof HTMLScriptElement && document.currentScript.src) {
            return new URL(document.currentScript.src).origin;
        }
    }
    catch (_a) {
        /* ignore */
    }
    try {
        const script = document.querySelector('script[data-lk-sandbox-id], script[data-mazed-agent]');
        if (script === null || script === void 0 ? void 0 : script.dataset.serverUrl) {
            return script.dataset.serverUrl.replace(/\/$/, '');
        }
        if (script === null || script === void 0 ? void 0 : script.src) {
            return new URL(script.src).origin;
        }
    }
    catch (_b) {
        /* ignore */
    }
    return '';
})();
export function getWidgetBaseUrl() {
    return _resolvedOrigin || window.location.origin;
}
